module.exports = __webpack_public_path__ + "static/js/dataToCsv.027e9a3d.chunk.worker.js"